module.exports = __webpack_public_path__ + "static/media/AkkuratPro-Regular.d58d6e6b.woff2";